import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Collapse } from 'antd';
import { useSelector, useDispatch } from "react-redux";
import { getAllGroups } from "../../../functions/accounts";

const { Panel } = Collapse;


const AccountsNav = () => {

    const [loading, setLoading] = useState(false);
    const [groups, setGroups] = useState([]);
    const [bank, setBank] = useState({})

    const { user } = useSelector((state) => ({ ...state }));

    const loadGroups = () => {
        getAllGroups(user.employee.store.company, user.token)
            .then((res) => {
                if (res.data) {
                    setGroups(res.data);
                    for (let i = 0; i < res.data.length; i++) {
                        if (res.data[i].title == 'Bank Account') {
                            setBank(res.data[i])
                        }
                    }
                }
            })
            .catch((err) => {
                console.log(err);
                //   toast.error(err.response.data.err);
            });
    }

    useEffect(() => {
        loadGroups()
    }, [])

    const onChange = (key) => {
        console.log(key);
    };

    return (
        <nav>
            <br />

            <Collapse className="nav flex-column" defaultActiveKey={['1']} onChange={onChange}>
                <Panel header="Accounts" key="1">
                    <ul>
                        <li className="nav-item">
                            <Link to="/accounts/dashboard" className="nav-link">
                                Home
                    </Link>
                        </li>
                        {/* <li className="nav-item">
                            <Link to="/storecharge/store-pos" className="nav-link">
                                POS
                           </Link>
                        </li> */}
                    </ul>
                </Panel>
                <Panel header="Vouchers" key="2">
                    <ul>
                        <li className="nav-item">
                            <Link to={`/accounts/voucher/bank-add?id=${bank._id}`} className="nav-link">
                                Bank Ledger Add
                            </Link>
                        </li>


                        {/* <li className="nav-item">
                            <Link to="/storecharge/store-pos" className="nav-link">
                                POS
                           </Link>
                        </li> */}
                    </ul>
                </Panel>
                <Panel header="Master" key="3">
                    <ul>
                        <li className="nav-item">
                            <Link to="/accounts/create-group" className="nav-link">
                                Create Group
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/accounts/create-sub" className="nav-link">
                                Create Sub
                           </Link>
                        </li>
                    </ul>
                </Panel>
                {/* <Panel header="Suppliers" key="4">
                    <ul>
                        <li className="nav-item">
                            <Link to="/admin/supplier-add" className="nav-link">
                                List All Suppliers
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/accounts/create-sub" className="nav-link">
                                Create Sub
                           </Link>
                        </li>
                    </ul>
                </Panel> */}
                <Panel header="GST" key="4">
                    <ul>
                        <li className="nav-item">
                            <Link to="/accounts/gst" className="nav-link">
                                GSTR-1
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/accounts/gstr-2" className="nav-link">
                                GSTR-2A
                           </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/accounts/gstr-3" className="nav-link">
                                GSTR-3B
                           </Link>
                        </li>
                    </ul>
                </Panel>
                <Panel header="Ledgers" key="5">
                    <ul>
                        {/* <li className="nav-item">
                            <Link to="/accounts/ledger?type=supplier" className="nav-link">
                               Supplier
                            </Link>
                        </li> */}
                        {/* <li className="nav-item">
                            <Link to={`/accounts/ledger?type=bank-account&&id=${bank._id}`} className="nav-link">
                                Bank Account
                            </Link>
                        </li> */}

                        <li className="nav-item">
                            <Link to={`/logistic/all-ledgers?company=${user.employee.store.company}`} className="nav-link">
                                All Ledgers
                            </Link>
                        </li>
                    </ul>
                </Panel>


            </Collapse>

        </nav>
    )
}

export default AccountsNav
